import { SearchEntityType } from "@/models/search/Search";
import {
  ChatSearchResult,
  LegislationSearchResult,
  SearchResult,
  WorkspaceDocumentSearchResult,
  WorkspaceSearchResult,
} from "@/models/search/SearchResults";

export interface ResultData {
  entityType: SearchEntityType;
  id: string;
  title: string;
  createdAt?: Date;
  updatedAt?: Date;
  entitySpecificInfo: Record<string, unknown>;
  data:
    | LegislationSearchResult
    | WorkspaceSearchResult
    | WorkspaceDocumentSearchResult
    | ChatSearchResult
    | null;
}

export const getResultData = (result: SearchResult): ResultData => {
  if (result.legislation) {
    return {
      entityType: result.legislation.entityType,
      id: result.legislation.id,
      title: result.legislation.title,
      updatedAt: undefined,
      entitySpecificInfo: {
        metadataObject: result.legislation.metadata,
        source: result.legislation.source,
      },
      data: result.legislation,
    };
  }

  if (result.workspace) {
    return {
      entityType: result.workspace.entityType,
      id: result.workspace.id,
      title: result.workspace.name,
      createdAt: result.workspace.createdAt,
      updatedAt: result.workspace.updatedAt,
      entitySpecificInfo: {
        fileCount: result.workspace.fileCount,
        folderCount: result.workspace.folderCount,
      },
      data: result.workspace,
    };
  }

  if (result.workspaceDocument) {
    return {
      entityType: result.workspaceDocument.entityType,
      id: result.workspaceDocument.id,
      title: result.workspaceDocument.name,
      createdAt: result.workspaceDocument.createdAt,
      updatedAt: result.workspaceDocument.updatedAt,
      entitySpecificInfo: {
        workspaceName: result.workspaceDocument.workspaceName,
        documentType: result.workspaceDocument.documentType,
      },
      data: result.workspaceDocument,
    };
  }

  if (result.chat) {
    return {
      entityType: result.chat.entityType,
      id: result.chat.id,
      title: result.chat.title || "Unavngivet chat",
      createdAt: result.chat.createdAt,
      updatedAt: result.chat.updatedAt,
      entitySpecificInfo: {
        messageCount: result.chat.messageCount,
      },
      data: result.chat,
    };
  }

  return {
    entityType: SearchEntityType.Legislation,
    id: "",
    title: "",
    createdAt: undefined,
    updatedAt: undefined,
    entitySpecificInfo: {},
    data: null,
  };
};
